<template>
    <div class="position-user">
        <div class="position-user__position">
            {{ user.ratingPosition }}
            <IconStar />
        </div>
        <div class="position-user__avatar">
            <img
                class="position-user__avatar-image"
                :src="user.avatar && user.avatar.url"
                :alt="user.name"
                v-if="user.avatar && user.avatar.url"
            />
            <svg
                width="56"
                height="56"
                viewBox="0 0 56 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="position-user__avatar-empty"
                v-else
            >
                <rect width="56" height="56" rx="16" fill="#EBF0F5" />
                <path
                    d="M13 41.3333C16.893 37.2043 22.1784 34.6667 28 34.6667C33.8216 34.6667 39.107 37.2043 43 41.3333M35.5 20.5C35.5 24.6421 32.1421 28 28 28C23.8579 28 20.5 24.6421 20.5 20.5C20.5 16.3579 23.8579 13 28 13C32.1421 13 35.5 16.3579 35.5 20.5Z"
                    stroke="#B5C1DD"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </div>
        <div class="position-user__name-and-region">
            <div class="position-user__name">{{ user.name }}</div>
            <div class="position-user__region">{{ user.regionName }}</div>
        </div>
        <div class="position-user__total-scores">
            <IconScore />
            {{ spaceInNumber(user.totalCoins || 0) }}
        </div>
    </div>
</template>

<script>
import IconStar from '@/components/ratings/svg/IconStar.vue';
import IconScore from '@/components/ratings/svg/IconScore.vue';
import spaceInNumber from '@/tools/spaceInNumber';

export default {
    name: 'PositionUser',
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
    components: { IconStar, IconScore },
    methods: {
        spaceInNumber: spaceInNumber,
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/mrem';

.position-user {
    display: grid;
    align-items: center;
    grid-template-columns: mrem(46) 1fr 1fr;
    padding: mrem(12) 0;
    gap: mrem(16);
    row-gap: mrem(8);
    width: 100%;

    * {
        font-family: 'Montserrat', sans-serif;
    }

    @include on-desktop {
        display: flex;
        padding: rem(16) 0;
        gap: 0;
        width: rem(1050);
    }

    &__position {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: mrem(8);
        width: mrem(50);
        grid-column: 2 / 3;
        grid-row: 2 / 3;

        font-family: 'Montserrat', sans-serif;
        font-weight: 700;
        font-size: mrem(12);

        line-height: mrem(20);

        text-align: center;
        color: #2a2626;

        @include on-desktop {
            flex-direction: column;

            width: rem(80);
            gap: rem(8);
            font-size: rem(16);
            line-height: rem(22);
            margin-right: rem(20);
        }
    }

    &__avatar {
        width: mrem(46);
        height: mrem(46);
        flex-shrink: 0;
        grid-column: 1 / 2;
        grid-row: 1 / 3;

        @include on-desktop {
            width: rem(56);
            height: rem(56);
            margin-right: rem(25);
        }
    }

    &__avatar-empty {
        width: mrem(46);
        height: mrem(46);
        border-radius: 50%;
        flex-shrink: 0;

        @include on-desktop {
            width: rem(56);
            height: rem(56);
            border-radius: 0;
        }
    }

    &__avatar-image {
        width: 100%;
        height: 100%;
        border-radius: 50%;

        @include on-desktop {
            object-fit: cover;
            border-radius: rem(16);
        }
    }

    &__name-and-region {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: mrem(6);
        grid-column: 2 / 4;

        @include on-desktop {
            gap: rem(4);
            width: rem(700);
            margin-right: rem(20);
        }
    }

    &__name {
        font-family: 'Montserrat', sans-serif;
        font-weight: 600;
        font-size: mrem(14);
        line-height: mrem(20);
        color: #251f45;

        @include on-desktop {
            font-weight: 700;
            font-size: rem(18);
            line-height: rem(26);
        }
    }

    &__region {
        font-family: 'Montserrat', sans-serif;
        font-weight: 500;
        font-size: mrem(14);
        line-height: mrem(20);
        color: #b5c1dd;

        @include on-desktop {
            font-size: rem(16);
            line-height: rem(24);
        }
    }

    &__total-scores {
        display: flex;
        align-items: center;
        gap: mrem(6);
        flex-grow: 1;
        font-family: 'Montserrat', sans-serif;
        font-weight: 600;
        font-size: mrem(12);
        line-height: mrem(20);
        color: #2a2626;
        grid-column: 3 / 4;
        grid-row: 2 / 3;

        @include on-desktop {
            font-weight: 700;
            font-size: rem(16);
            line-height: rem(24);
            gap: rem(6);
        }
    }
}
</style>
